<template>
  <a-popover
      v-model="visible"
      trigger="click"
      placement="bottomRight"
      overlayClassName="header-org-switcher-popover"
  >
    <div slot="content" class="org-popover-content">
      <a-input
          v-model="searchText"
          :placeholder="$t('label.search')"
          size="small"
          allow-clear
          class="org-search-input"
      >
        <a-icon slot="prefix" type="search"/>
      </a-input>

      <div class="org-list">
        <div
            v-for="org in filteredOrganizations"
            :key="org.id"
            class="org-item"
            :class="{ active: org.id === value }"
            @click="selectOrg(org.id)"
        >
          {{ org.label }}
        </div>
        <div v-if="!filteredOrganizations.length" class="org-empty text-grey">
          {{ $t('label.no_data') }}
        </div>
      </div>
    </div>

    <a-tooltip :title="currentOrgName" :mouseEnterDelay="0.5">
      <div class="org-trigger" :class="{ open: visible }">
        <buildings-icon width="16" height="16" stroke="#467BFF"/>
        <span class="org-trigger-name">{{ currentOrgName || $t('label.organization') }}</span>
        <svg
            class="org-trigger-arrow"
            width="10" height="6" viewBox="0 0 10 6"
            fill="none" xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L5 5L9 1" stroke="#6886A6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </a-tooltip>
  </a-popover>
</template>

<script>
import BuildingsIcon from '@/assets/icons/buildingsIcon';

export default {
  name: 'HeaderOrgSwitcher',
  components: {BuildingsIcon},
  props: {
    value: {default: null},
    organizations: {type: Array, default: () => []}
  },
  data() {
    return {
      visible: false,
      searchText: ''
    };
  },
  computed: {
    currentOrgName() {
      if (!this.value || !this.organizations.length) return null;
      const org = this.organizations.find(o => o.id === this.value);
      return org ? org.label : null;
    },
    filteredOrganizations() {
      if (!this.searchText) return this.organizations;
      const search = this.searchText.toLowerCase();
      return this.organizations.filter(o => o.label.toLowerCase().includes(search));
    }
  },
  watch: {
    visible(val) {
      if (!val) this.searchText = '';
    }
  },
  methods: {
    selectOrg(orgId) {
      this.visible = false;
      if (orgId !== this.value) {
        this.$emit('change', orgId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.org-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  background: rgba(70, 123, 255, 0.06);
  border: 1px solid rgba(70, 123, 255, 0.15);
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 260px;
  height: 28px;

  &:hover, &.open {
    background: rgba(70, 123, 255, 0.1);
    border-color: rgba(70, 123, 255, 0.3);
  }

  .org-trigger-name {
    font-size: 12px;
    font-weight: 500;
    color: #132540;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    line-height: 1;
  }

  .org-trigger-arrow {
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &.open .org-trigger-arrow {
    transform: rotate(180deg);
  }
}

.org-popover-content {
  width: 260px;

  .org-search-input {
    margin-bottom: 8px;
  }

  .org-list {
    max-height: 240px;
    overflow-y: auto;
  }

  .org-item {
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    color: #132540;
    transition: background 0.15s ease;

    &:hover {
      background: #F0F5FF;
    }

    &.active {
      background: rgba(70, 123, 255, 0.1);
      color: #467BFF;
      font-weight: 500;
    }
  }

  .org-empty {
    padding: 12px;
    text-align: center;
    font-size: 13px;
  }
}

@media screen and (max-width: 768px) {
  .org-trigger {
    max-width: 180px;
    padding: 3px 8px;
    gap: 4px;
    height: 26px;

    .org-trigger-name {
      max-width: 120px;
      font-size: 11px;
    }
  }
}
</style>
